import React, { Component } from "react";
import "react-moment";
import moment from "moment";
import ReporteVentasCompras from "./ReporteVentasCompras";

class DashboardSire extends Component {
    constructor(props){
        super(props);
        this.state = {
            FechaInicio: moment().add(-30, 'days'),
            FechaFin: new Date(),
            loadedSections: {
                reporteVentasCompras: false
            },
            loadingSections: {
                reporteVentasCompras: false
            }
        };

        this.timeoutRefs = {
            reporteVentasCompras: null
        };
    }

    componentWillUnmount() {
        Object.values(this.timeoutRefs).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        });
    }

    handleAccordionToggle(section, isExpanding) {
        if (this.timeoutRefs[section]){
            clearTimeout(this.timeoutRefs[section]);
        }

        if (isExpanding && !this.state.loadedSections[section]){
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: true
                }
            }));

            this.timeoutRefs[section] = setTimeout(() => {
                this.loadSectionData(section);
            }, 800);
        }
    }

    async loadSectionData(section) {
        try {
            // await this.getVentas();
            // await this.getCompras();
            
            this.setState(prevState => ({
                loadedSections: {
                    ...prevState.loadedSections,
                    [section]: true
                },
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));

        } catch (error) {
            console.error(`Error loading ${section}:`, error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));
        }
    }

    render() {
        const { loadedSections, loadingSections, FechaInicio, FechaFin } = this.state;
        
        return (
            <section className="ventas-fpay-section-vh">
                <div className="container-fluid px-md-5">
                    <div className="mb-2 pt-3">
                        <h4 className="mt-2 text-center">REPORTE GENERALES SIRE</h4>
                        <div className="accordion pb-5" id="accordionExample">
                            
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingOne">
                                    <h2 className="mb-0 text-center">
                                        <button
                                            className="btn"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                            style={{ width: '100%' }}
                                            onClick={() => this.handleAccordionToggle('reporteVentasCompras', true)}
                                        >
                                            REPORTE DE VENTAS Y COMPRAS
                                        </button>
                                    </h2>
                                </div>
                                <div className="collapse show" id="collapseOne" 
                                    aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.reporteVentasCompras ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando reporte de ventas y compras...</p>
                                            </div>
                                        ) : loadedSections.reporteVentasCompras ? (
                                            <div className="reporte-container">
                                                <ReporteVentasCompras 
                                                    FechaInicio={FechaInicio}
                                                    FechaFin={FechaFin}
                                                />
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-pie fa-2x mb-2"></i>
                                                <p>Expande para cargar el reporte de ventas y compras</p>
                                            </div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default DashboardSire;